import styled from "styled-components";

import { alignItemsCenter, flexSpBetween, rem } from "@styles/Utilities.styled";


export const StyledLaboratory = styled.section`
  margin-top: 2rem;

  .header {
    ${flexSpBetween}
    padding-bottom: 0.75rem;
  }

  .filters-wrapper {
    ${flexSpBetween}
    gap: 3rem;
    margin-top: 2rem;

    .dropdown-wrapper {
      ${alignItemsCenter}
      gap: 1rem;
    }
  }

  table {
    margin-top: 2rem;

    tr {
      cursor: unset;
    }
  }

  .type-wrapper {
    ${alignItemsCenter}
    gap: 0.5rem;

    svg {
      path {
        stroke: var(--clr-accent);
      }
    }
  }
`;
